import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  ContentChild,
  effect,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { select, Store } from '@ngxs/store';
import {
  AnimateModule,
  GtmClickDirective,
  SwiperDirective,
  UserType,
  WwwAppState,
  WwwRouteSlug,
} from '@pro-connect/shared';
import { AccountState, AccountStateAddEvent } from 'shared/src/pages/core/pages/account/account.state';
import { IProEducationTraining } from '../../models/pro-education-training';
import { IProEducationEvent } from '../../models/pro-education-event';
import { IAccountOrder } from 'shared/src/pages/core/pages/account/models/account-order';
import { ToastrService } from 'ngx-toastr';
import { NgxMaskPipe } from 'ngx-mask';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-pro-edu-tra-tic',
  templateUrl: './pro-edu-tra-tic.component.html',
  styleUrls: ['./pro-edu-tra-tic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule, NgxMaskPipe, SwiperDirective, GtmClickDirective],
})
export class ProEduTraTicComponent implements OnInit {
  protected readonly _toastrService: ToastrService = inject(ToastrService);
  private readonly _store: Store = inject(Store);

  public markedEvent = input<IProEducationEvent | null>(null);
  public readonly UserType = UserType;
  public readonly user = select(WwwAppState.user);
  public readonly accountOrders = select(AccountState.events);
  // public markedEvent = select(ProEducationTrainingState.markedEvent);
  // public markedEventEl: WritableSignal<IProEducationEvent | null> = signal(null);
  protected readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('swiper') swiperRef!: ElementRef<SwiperContainer>;

  public readonly swiperConfig: SwiperOptions = {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    // effect: 'coverflow',
    breakpoints: {
      480: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: '.www-pro-edu-tra-tic__list__swi__nav--pag',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.www-pro-edu-tra-tic__list__swi__nav--next',
      prevEl: '.www-pro-edu-tra-tic__list__swi__nav--prev',
    },
  };

  public readonly hasAccessToEvent = computed(() => {
    if (!this.user() || !this.trainingDetails()) {
      return false;
    } else if (this.trainingDetails()?.brands.length < 1) {
      return true;
    }
    return this.trainingDetails().brands.some((b) => this.user()?.brands.includes(b));
  });

  public trainingDetails = input.required<IProEducationTraining>();
  public expandedTicket: WritableSignal<number | null> = signal(null);
  public WwwRouteSlug = WwwRouteSlug;
  public addEventToOrder(event: IProEducationEvent): void {
    if (this.trainingDetails().slug !== 'sniadanie-networkingowe') {
      const accountEvent: IAccountOrder = {
        id: event.id,
        photo: this.trainingDetails().main_photo,
        name: this.trainingDetails().name,
        price: this.trainingDetails().price,
        start_date: event.start_date,
        end_date: event.end_date,
        seats: event.seats,
        free_seats: event.free_seats,
        place: event.place,
        places: 1,
      };
      this._store.dispatch([new AccountStateAddEvent({ event: accountEvent })]);
      this._toastrService.success('Dodano do koszyka');
    } else {
      this._toastrService.success('Skontaktuj się z Business Partnerem.');
      return;
    }
  }

  constructor() {
    effect(() => {
      if (this.markedEvent() && this.swiperRef?.nativeElement?.swiper) {
        this.swiperRef.nativeElement.swiper.slideTo(
          this.trainingDetails().events.findIndex((e: IProEducationEvent) => e.id === this.markedEvent()?.id),
        );
        this._changeDetectorRef.detectChanges();
        this.swiperRef.nativeElement.swiper.updateSlides();
      }
    });
  }

  public ngOnInit(): void {}

  public networkingEventCommunicate(): void {
    this._toastrService.warning('Aby wziąć udział w śniadaniu, skontaktuj się z Twoim Business Partnerem!');
  }
}
